import { HttpParams } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';

@Component({
    selector: 'hap-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
    loginSubscription: Subscription | undefined;
    loginText: string;
    userData: UserDataResult;

	constructor(
		private _oidcSecurityService: OidcSecurityService,
		private _router: Router) {
		this.getRedirectQueryString();
	}

    ngOnInit() {
        this._oidcSecurityService.authorize();
    }

    ngOnDestroy(): void {
        if(this.loginSubscription) {
          this.loginSubscription.unsubscribe();
        }
      }

    getRedirectQueryString()	{
		let url = this._router.url;
		let paramValue: string;
        if (url && url.includes('?')) {
            const httpParams = new HttpParams({ fromString: url.split('?')[1] });
            paramValue = httpParams.get("redirectTo");
            if (paramValue) {
                localStorage.setItem("redirectTo", paramValue);
            }
            paramValue = httpParams.get("singleAppRedirect");
            if (paramValue) {
                localStorage.setItem("singleAppRedirect", "true");
            }
        }
	}
}
